const dimension = {
  dimension: "Dimensión",
  dimensions: "Dimensiones",
  add_dimension: "Agregar dimensión",
  edit_dimension: "Editar dimensión",
  name: "Nombre",
  value: "Valor",
  code: "Código",
  description: "Descripción",
  actions: "Acciones",
  edit: "Editar",
  delete: "Eliminar",
  view_dimension_values: "Ver valores de dimensión",
  dimension_values: "Valores de dimensión",
  add_dimension_value: "Agregar valor de dimensión",
  edit_dimension_value: "Editar valor de dimensión",
  name_required: "El nombre es obligatorio",
  value_required: "El valor es obligatorio",
  code_required: "El código es obligatorio",
  dimension_created_successfully: "Dimensión creada correctamente",
  dimension_updated_successfully: "Dimensión actualizada correctamente",
  dimension_deleted_successfully: "Dimensión eliminada correctamente",
  dimension_value_created_successfully:
    "Valor de dimensión creado correctamente",
  dimension_value_updated_successfully:
    "Valor de dimensión actualizado correctamente",
  dimension_value_deleted_successfully:
    "Valor de dimensión eliminado correctamente",
  delete_dimension_title: "Eliminar dimensión",
  delete_dimension_description:
    "¿Está seguro de que desea eliminar esta dimensión?",
  delete_dimension_value_title: "Eliminar valor de dimensión",
  delete_dimension_value_description:
    "¿Está seguro de que desea eliminar este valor de dimensión?",
  no_dimensions_found: "No se encontraron dimensiones",
  no_dimension_values_found: "No se encontraron valores de dimensión",
  cancel: "Cancelar",
  save: "Guardar",
  add: "Agregar",
  update: "Actualizar",
  something_went_wrong: "Algo salió mal",
  add_filter: "Agregar filtro",
  filter_dimension_values: "Filtrar valores de dimensión",
  clear_all: "Limpiar todo",
  apply: "Aplicar",
  values: "Valores",
  dimension_has_active_values:
    "La dimensión tiene valores activos y no se puede eliminar.",
  dimension_id_required: "El ID de la dimensión es obligatorio.",
  dimension_is_system_reserved:
    "Esta dimensión está reservada por el sistema y no se puede modificar ni eliminar.",
  dimension_name_already_exists: "Ya existe una dimensión con el mismo nombre.",
  dimension_name_required: "El nombre de la dimensión es obligatorio.",
  dimension_not_found: "Dimensión no encontrada.",
  dimension_not_found_or_not_allowed:
    "Dimensión no encontrada o no tiene permiso para agregar valores a ella.",
  dimension_value_name_required:
    "El nombre del valor de dimensión es obligatorio.",
  dimension_value_not_found: "Valor de dimensión no encontrado.",
  dimension_value_required: "El valor de dimensión es obligatorio.",
  dimension_value_value_required: "El valor de dimensión es obligatorio.",
  not_allowed_to_delete_dimension:
    "No tiene permiso para eliminar esta dimensión.",
  not_allowed_to_delete_dimension_value:
    "No tiene permiso para eliminar este valor de dimensión.",
  not_allowed_to_update_dimension:
    "No tiene permiso para actualizar esta dimensión.",
  not_allowed_to_update_dimension_value:
    "No tiene permiso para actualizar este valor de dimensión.",
  organization_not_found:
    "No se encontró la organización para el usuario actual.",
  dimension_name_cannot_be_updated_for_system_reserved:
    "El nombre de la dimensión no se puede actualizar porque está reservado por el sistema.",
  dimension_name_invalid_format:
    "El nombre de la dimensión debe contener solo letras en inglés, sin espacios ni caracteres especiales.",
};

export default dimension;
